import i18n from 'invision-core/src/components/i18n/i18n';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import clone from 'ramda/src/clone';
import moment from 'moment';
import { LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { BackButtonTextSelector, CartHasItemsSelector, CartTabViewModel, FormattedCityStateSelector, FormattedNameSelector, ForwardButtonTextSelector, HasCustomerInfoSelector, IsCreatingModeSelector, IsModifyingModeSelector, IsPreviousRouteDashboardSelector, IsReplacingModeSelector, IsRestoringModeSelector, PreviousRouteSelector, QuoteTabViewModel, WizardTitleCustomerOrServiceSelector, WizardTitleLocaleSelector } from './create.products.order.wizard.selectors';
import { ChildSubscriptionIdSelector, CurrentSubscriptionIdSelector, CurrentSubscriptionSelector, EditSubscriptionItemSelector, SubscriptionErrorSelector } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
import { SelectedInventoryNameSelector } from '../../../../../reducers/selectors/customer.inventory.selectors';
import { clearCurrentSubscription, retrieveSubscription } from '../../../../../reducers/actions/customer.subscriptions.actions';
import { initializeReplaceOrder, retrieveOrderQuote, setReplaceItem, setSelectedProductId } from '../../../../../reducers/actions/products.order.actions';
import FaultCodeKeys from '../../../../../api/fault.code.keys';
import { addMultipleAndUpdateShoppingCart, calculateChangeOfServiceOrderQuote, calculateModifyOrderQuote, calculateOrderQuote, calculateRenewOrderQuote, cancelOrder, clearOrderQuote, editMultipleAndUpdateShoppingCart, goToNextStep, goToPreviousStep, goToStep, reinitializeProductOrder, removeFromAndUpdateShoppingCart, setCurrentStepIsInvalid, setEditOrderAdditionalProperty, setEditOrderAdditionalPropertyOnChange, setSelectedShippingMethodId, setSelectedTab, setShoppingCartItemIndex, submitGiftOrder, submitModifyOrder, submitOrder, submitRestoreOrder, submitServiceFeatureOrder, updateServiceFeatureQuantityPromise, updateShoppingCartWithLatest } from '../../../../../reducers/actions/products.wizard.actions';
import { ChangeImmediateSelector, CurrentStepIsInvalidSelector, CurrentStepSelector, FeatureOrderProductPricingPlanQuantitySelector, IsCheckoutStepSelector, IsProductsStepSelector, IsProductWizardRestoreOrderWaivingFeeSelector, IsProductWizardRestoreOrderWaivingLateFeeSelector, OrderAdditionalPropertiesSelector, OrderAdditionalPropertyListMapSelector, OttExecutionOptionsSelector, PaymentInstrumentIdsSelector, PaymentInstrumentsSelector, PaymentInstrumentsCleanSelector, ProductOrderShippingAddressIdSelector, ProductOrderShippingMethodIdSelector, ProductWizardGiftOrderInfoSelector, ProductWizardIsGiftOrderSelector, ProductWizardOrderDetailsSelector, ProductWizardRestoreOrderWaiveFeeReasonSelector, ProductWizardRestoreOrderWaiveLateFeeReasonSelector, ProductWizardTemporaryShipToNameSelector, SelectedTabIndexSelector, ShowPreviousButtonSelector, TabPanelViewModelSelector } from '../../../../../reducers/selectors/products.wizard.selectors';
import { CreatedOrderSelector, DiscretionaryDiscountsIdSelector, DiscretionaryDiscountsReasonSelector, HasPrepaidPricingPlanSelector, InvalidCouponRedemptionsSelector, InvalidItemsSelector, IsAsyncCompleteSelector, IsCalculatingQuoteSelector, IsDbssShoppingCart, IsFetchingSelector, IsServiceFeatureShoppingCart, IsSubmittingOrderSelector, ModifiedSubscriptionItemSelector, ModifySubscriptionRequestDataSelector, OrderRequiresShippingSelector, OrderSubscriptionQuotesAsMutableSelector, ProductOfferAsyncIdSelector, ProductOrderDataListSelector, RemovedOrderSelector, ReplaceCartItemSelector, ReplacementCartItemSelector, SearchCouponCodeSelector, SelectedCustomerAddressSelector, SelectedInventoryStoreDetailsSelector, SelectedProductIdSelector, SelectedServiceIdentifierSelector, ShippingMethodsViewModel, ShoppingCartIsDirtySelector, ShoppingCartItemDetailsLocationCodesSelector, ShoppingCartSelector, SkipToCheckoutSelector, SubmitChangeOfServiceForServiceFeatureRequestSelector, SubmitChangeOfServiceForServiceFeatureWithoutQuantitiesRequestSelector, UnfilteredCouponCodesSelector, ViewLastAttemptErrorSelector } from '../../../../../reducers/selectors/products.order.selectors';
import { INVENTORY_CATEGORIES } from '../../../inventory/inventory.constants';
import { CurrentCustomerSelector, RouteParams, RouteState } from '../../../../../reducers/selectors/customer.selectors';
import { getExistingQuantities, processServiceFeatures } from './steps/products/productDialog/product.dialog.helpers';
import { CREATE_PRODUCTS_ORDER_STATE_NAME, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS } from '../../../../../reducers/constants/products.wizard.constants';
import { RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../../../../src/customercare.constants';
import * as SubscriptionHelper from '../../../subscriptions/subscription.helper';
import CustomerCareKeys from '../../../../../locales/keys';
import SubscriptionOrder from './subscriptionHelpers/subscription.order';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../../../subscriptions/subscriptions.config';
import { isServiceFeatureOrder } from '../productsOrder/steps/products/products.wizard.helper';
import { IsFetchingOrdersSelector, OrdersSelector } from '../../../../../reducers/selectors/order.history.selectors';
import { IsFetchingAccountDetailsSelector, CurrentConvergentBillerSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveConvergentBillerAccountDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { searchOrders } from '../../../../../reducers/actions/order.history.actions';
import { asyncRepeatInterval } from '../../../../../reducers/helpers/async.helper';
import { PaymentIsFetchingDataSelector, RecordPaymentInformationSelector } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { retrieveCandidateBillCycles } from '../../../../../reducers/actions/customer.billcycle.actions';
import { setReloadSubscriberStateFlag } from '../../../../../reducers/actions/customer.actions';
import { CUSTOMER_CATEGORY } from '../../../../createCustomerPopup/create.customer.popup.constants';
var clearStore = function clearStore(actions) {
  actions.reinitializeProductOrder();
  actions.clearCurrentSubscription();
};
var TAX_LOCATION_CONSTANTS = {
  CUSTOMER_ADDRESS: 2,
  DEFAULT: 1,
  NPA_NXX: 3,
  STORE_LOCATION: 4
};
function ProductsWizardController($ngRedux, $log, $state, $timeout, unsavedChangesPrompt, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      additionalPropValueOptions: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
      asyncId: ProductOfferAsyncIdSelector(store),
      backButtonText: BackButtonTextSelector(store),
      cartHasItems: CartHasItemsSelector(store),
      cartTab: CartTabViewModel(store),
      changeImmediately: ChangeImmediateSelector(store),
      convergentBiller: CurrentConvergentBillerSelector(store),
      couponCodes: UnfilteredCouponCodesSelector(store),
      createdOrder: CreatedOrderSelector(store),
      currentCustomer: CurrentCustomerSelector(store),
      currentStep: CurrentStepSelector(store),
      currentStepIsInvalid: CurrentStepIsInvalidSelector(store),
      currentSubscription: CurrentSubscriptionSelector(store),
      currentSubscriptionChildItemId: ChildSubscriptionIdSelector(store),
      currentSubscriptionId: CurrentSubscriptionIdSelector(store),
      defaultRoute: PreviousRouteSelector(store),
      discretionaryDiscountIds: DiscretionaryDiscountsIdSelector(store),
      discretionaryDiscountReason: DiscretionaryDiscountsReasonSelector(store),
      editSubscriptionItem: EditSubscriptionItemSelector(store),
      executionOptions: OttExecutionOptionsSelector(store),
      featureOrderQuantities: FeatureOrderProductPricingPlanQuantitySelector(store),
      formattedCityState: FormattedCityStateSelector(store),
      formattedName: FormattedNameSelector(store),
      forwardButtonText: ForwardButtonTextSelector(store),
      giftOrderInfo: ProductWizardGiftOrderInfoSelector(store),
      hasCustomerInfo: HasCustomerInfoSelector(store),
      hasPrepaid: HasPrepaidPricingPlanSelector(store),
      // used w/ SubscriptionOrder (via Submit(Gift|Modify|Restore)Order flow)
      invalidCouponRedemptions: InvalidCouponRedemptionsSelector(store),
      invalidItems: InvalidItemsSelector(store),
      isAsyncComplete: IsAsyncCompleteSelector(store),
      isCalculatingQuote: IsCalculatingQuoteSelector(store),
      isCheckoutStep: IsCheckoutStepSelector(store),
      isCreatingMode: IsCreatingModeSelector(store),
      isDbssBU: IsDbss(store),
      isDbssShoppingCart: IsDbssShoppingCart(store),
      isFetchingAccountDetails: IsFetchingAccountDetailsSelector(store),
      isFetchingData: IsFetchingSelector(store),
      isFetchingOrders: IsFetchingOrdersSelector(store),
      isFetchingWalletData: PaymentIsFetchingDataSelector(store),
      isGiftOrder: ProductWizardIsGiftOrderSelector(store),
      isModifyingMode: IsModifyingModeSelector(store),
      isPreviousRouteDashboard: IsPreviousRouteDashboardSelector(store),
      isProductsStep: IsProductsStepSelector(store),
      isReplacingMode: IsReplacingModeSelector(store),
      isRestoringMode: IsRestoringModeSelector(store),
      isServiceFeatureShoppingCart: IsServiceFeatureShoppingCart(store),
      isSubmittingOrder: IsSubmittingOrderSelector(store),
      lastAttemptError: ViewLastAttemptErrorSelector(store),
      lastRoute: LastRouteSelector(store),
      locationCodes: ShoppingCartItemDetailsLocationCodesSelector(store),
      modifiedItem: ModifiedSubscriptionItemSelector(store),
      modifyItemRequestData: ModifySubscriptionRequestDataSelector(store),
      orderAdditionalProperties: OrderAdditionalPropertiesSelector(store),
      orderAdditionalPropertyListMap: OrderAdditionalPropertyListMapSelector(store),
      orderDetails: ProductWizardOrderDetailsSelector(store),
      orderRequiresShipping: OrderRequiresShippingSelector(store),
      orders: OrdersSelector(store),
      paymentInstrumentIds: PaymentInstrumentIdsSelector(store),
      paymentInstruments: PaymentInstrumentsSelector(store),
      paymentInstrumentsClean: PaymentInstrumentsCleanSelector(store),
      productsList: ProductOrderDataListSelector(store),
      quoteTab: QuoteTabViewModel(store),
      recordPaymentInfo: RecordPaymentInformationSelector(store),
      removedOrder: RemovedOrderSelector(store),
      replaceItem: ReplaceCartItemSelector(store),
      replacementItem: ReplacementCartItemSelector(store),
      routeParams: RouteParams(store),
      routeState: RouteState(store),
      searchCouponCode: SearchCouponCodeSelector(store),
      selectedCustomerAddress: SelectedCustomerAddressSelector(store),
      selectedInventoryStore: SelectedInventoryStoreDetailsSelector(store),
      selectedInventoryName: SelectedInventoryNameSelector(store),
      selectedProductId: SelectedProductIdSelector(store),
      selectedServiceIdentifier: SelectedServiceIdentifierSelector(store),
      selectedTabIndex: SelectedTabIndexSelector(store),
      shippingAddressId: ProductOrderShippingAddressIdSelector(store),
      shippingMethodId: ProductOrderShippingMethodIdSelector(store),
      shippingMethods: ShippingMethodsViewModel(store),
      shipToName: ProductWizardTemporaryShipToNameSelector(store),
      shoppingCart: ShoppingCartSelector(store),
      shoppingCartIsDirty: ShoppingCartIsDirtySelector(store),
      showPreviousButton: ShowPreviousButtonSelector(store),
      skipToCheckout: SkipToCheckoutSelector(store),
      structureTypesLoaded: MetadataCodeLoadedSelector(CODES.StructureType, store),
      submitChangeOfServiceForServiceFeatureRequest: SubmitChangeOfServiceForServiceFeatureRequestSelector(store),
      submitChangeOfServiceForServiceFeatureWithoutQuantitiesRequest: SubmitChangeOfServiceForServiceFeatureWithoutQuantitiesRequestSelector(store),
      subscriptionError: SubscriptionErrorSelector(store),
      subscriptionQuotes: OrderSubscriptionQuotesAsMutableSelector(store),
      subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
      subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
      tabs: TabPanelViewModelSelector(store),
      waiveFee: IsProductWizardRestoreOrderWaivingFeeSelector(store),
      waiveFeeReason: ProductWizardRestoreOrderWaiveFeeReasonSelector(store),
      waiveLateFee: IsProductWizardRestoreOrderWaivingLateFeeSelector(store),
      waiveLateFeeReason: ProductWizardRestoreOrderWaiveLateFeeReasonSelector(store),
      wizardTitleCustomerOrService: WizardTitleCustomerOrServiceSelector(store),
      wizardTitleLocale: WizardTitleLocaleSelector(store)
    };
  };
  this.$onInit = function () {
    var controllerActions = {
      addMultipleAndUpdateShoppingCart: addMultipleAndUpdateShoppingCart,
      calculateChangeOfServiceOrderQuote: calculateChangeOfServiceOrderQuote,
      calculateModifyOrderQuote: calculateModifyOrderQuote,
      calculateOrderQuote: calculateOrderQuote,
      calculateRenewOrderQuote: calculateRenewOrderQuote,
      cancelOrder: cancelOrder,
      clearCurrentSubscription: clearCurrentSubscription,
      clearOrderQuote: clearOrderQuote,
      editMultipleAndUpdateShoppingCart: editMultipleAndUpdateShoppingCart,
      goToNextStep: goToNextStep,
      goToPreviousStep: goToPreviousStep,
      goToStep: goToStep,
      initializeReplaceOrder: initializeReplaceOrder,
      registerUnsavedChanges: registerUnsavedChanges,
      reinitializeProductOrder: reinitializeProductOrder,
      removeFromAndUpdateShoppingCart: removeFromAndUpdateShoppingCart,
      retrieveCandidateBillCycles: retrieveCandidateBillCycles,
      retrieveConvergentBillerAccountDetails: retrieveConvergentBillerAccountDetails,
      retrieveOrderQuote: retrieveOrderQuote,
      retrieveSubscription: retrieveSubscription,
      searchOrders: searchOrders,
      setCurrentStepIsInvalid: setCurrentStepIsInvalid,
      setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
      setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
      setReloadSubscriberStateFlag: setReloadSubscriberStateFlag,
      setReplaceItem: setReplaceItem,
      setSelectedProductId: setSelectedProductId,
      setSelectedShippingMethodId: setSelectedShippingMethodId,
      setSelectedTab: setSelectedTab,
      setShoppingCartItemIndex: setShoppingCartItemIndex,
      submitGiftOrder: submitGiftOrder,
      submitModifyOrder: submitModifyOrder,
      submitOrder: submitOrder,
      submitRestoreOrder: submitRestoreOrder,
      submitServiceFeatureOrder: submitServiceFeatureOrder,
      unregisterUnsavedChanges: unregisterUnsavedChanges,
      updateServiceFeatureQuantityPromise: updateServiceFeatureQuantityPromise,
      updateShoppingCartWithLatest: updateShoppingCartWithLatest
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.retrieveOrderQuoteTimestamp = null;
    _this.customerCategory = CUSTOMER_CATEGORY, _this.customerCareKeys = CustomerCareKeys;
    _this.isServiceFeatureOrder = isServiceFeatureOrder(_this.state.routeParams);
    _this.wizardContinueClicked = false;
    _this.selectOptionsPopupApi = null;
    _this.taxAndGlValuesRequired = false;
    _this.INVENTORY_CATEGORIES = INVENTORY_CATEGORIES;
    _this.selectOptionsPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.selectOptionsPopupApi = api;
      }
    };
    _this.editProfileInformationPopupConfig = {
      onRegisterApi: function onRegisterApi(_ref2) {
        var api = _ref2.api;
        _this.editProfileInformationPopupApi = api;
      }
    };
    _this.closeDialog = function () {
      _this.showOptionsModalPopup = false;
      _this.selectOptionsPopupApi.close();
    }.bind(_this);
    _this.onOptionSelect = function (id) {
      if (_this.state.isReplacingMode && _this.state.cartTab.items.length) {
        _this.openUpdateOrderConfirmation(id);
      } else {
        _this.openProductModal(i18n.translate(CustomerCareKeys.PRODUCT_OPTIONS.OPTIONS), id);
      }
    };
    _this.onQuickView = function (id) {
      _this.openProductModal(i18n.translate(CustomerCareKeys.PRODUCT_OPTIONS.DETAILS), id);
    };
    _this.openProductModal = function (tabName, id) {
      _this.actions.setSelectedProductId(id);
      _this.selectedTab = tabName;
      _this.showOptionsModalPopup = true;
      $timeout(function () {
        _this.selectOptionsPopupApi.open();
      });
    };
    _this.centerSelectOptionsPopup = function () {
      _this.selectOptionsPopupApi.center();
    };
    _this.productSelected = function (shoppingCart, addedItems, isFailure, serviceFeatureModel) {
      if (shoppingCart && !_this.state.isCreatingMode) {
        var itemsInCart = !_this.isServiceFeatureOrder ? addedItems.some(function (addedItem) {
          return shoppingCart.ShoppingCart.Items.some(function (cartItem) {
            return addedItem.pricingPlanId === cartItem.PricingPlanId && addedItem.productId === cartItem.ProductId && !!cartItem.Quantity;
          });
        }) : null;
        if (itemsInCart) {
          uiNotificationService.warning(i18n.translate(CustomerCareKeys.CART.DUPLICATE_ITEM_WARNING));
        }
      }
      if (_this.state.invalidItems.length) {
        _this.state.invalidItems.forEach(function (invalidItem) {
          uiNotificationService.error(invalidItem.productName ? i18n.translate(CustomerCareKeys.CART.ITEM_NOT_ADDED_NAMED, {
            productName: invalidItem.productName
          }) : i18n.translate(CustomerCareKeys.CART.ITEM_NOT_ADDED_GENERIC));
        });
      }
      _this.onProductSelected();
      if (_this.isServiceFeatureOrder) {
        if (isFailure) {
          _this.actions.updateServiceFeatureQuantityPromise({
            AddItems: pathOr([], ['shoppingCart', 'AddItems'], _this.serviceFeatureModel),
            RemoveItems: pathOr([], ['shoppingCart', 'RemoveItems'], _this.serviceFeatureModel)
          });
        } else {
          _this.serviceFeatureModel = serviceFeatureModel;
        }
      }
    }.bind(_this);
    if (!_this.state.skipToCheckout) {
      clearStore(_this.actions);
    }
    if (_this.isServiceFeatureOrder) {
      _this.actions.searchOrders(_this.state.currentCustomer.Id);
      _this.actions.retrieveConvergentBillerAccountDetails(_this.state.currentCustomer.Id).then(function () {
        if (_this.state.featureOrderQuantities && _this.state.featureOrderQuantities.length && !_this.state.shoppingCartIsDirty) {
          var model = {
            products: _this.state.featureOrderQuantities,
            customerId: _this.state.currentCustomer.Id,
            shoppingCart: _this.state.shoppingCart,
            redemptionCodes: []
          };
          _this.actions.addMultipleAndUpdateShoppingCart(model, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS);
        }
      });
    }
    if (_this.state.isReplacingMode) {
      _this.initializeReplaceMode();
    } else if (_this.state.isModifyingMode) {
      var cartItem = SubscriptionHelper.createSubscriptionCartItem(_this.state.currentSubscription);
      _this.actions.setReplaceItem(cartItem);
    } else if (_this.state.isRestoringMode) {
      var order = new SubscriptionOrder(_this.state).createOrder({
        useDefaults: false,
        calculateTaxes: false
      });
      _this.actions.calculateRenewOrderQuote(order);
    }
    _this.onEditCartItem = function (cartItem) {
      _this.actions.setShoppingCartItemIndex(cartItem.index);
      _this.openProductModal(i18n.translate(CustomerCareKeys.PRODUCT_OPTIONS.OPTIONS), cartItem.productId);
    };
    _this.onEditedCartItem = function (cartItem) {
      if (!_this.isServiceFeatureOrder && cartItem && _this.state.shoppingCart && (_this.state.shoppingCart.Items || []).find(function (item) {
        return cartItem.pricingPlanId === item.PricingPlanId && cartItem.productId === item.ProductId && !!item.Quantity;
      })) {
        uiNotificationService.warning(i18n.translate(CustomerCareKeys.CART.DUPLICATE_ITEM_WARNING));
      }
      _this.actions.setSelectedProductId(null);
      _this.calculateOrderQuote();
    };
    _this.actions.registerUnsavedChanges('productsOrderWizard', {
      isDirty: function isDirty() {
        return _this.state.cartHasItems;
      },
      setPristine: function setPristine() {
        _this.handleCancel();
      }
    });
    _this.stateOrName = CREATE_PRODUCTS_ORDER_STATE_NAME;

    // Submit Order Success Confirmation Popup
    _this.orderConfirmationPopup = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.orderConfirmationPopup = evt.api;
      }
    };

    // Submit Order Failure Error Popup
    _this.submitOrderErrorPopup = {
      onRegisterApi: function onRegisterApi(evt) {
        _this.submitOrderErrorPopup = evt.api;
      }
    };
    _this.repeatRetrieveQuote = function () {
      asyncRepeatInterval(_this.onRefreshQuote, function () {
        return !_this.state.isAsyncComplete && _this.state.isCheckoutStep;
      });
    }.bind(_this);
    _this.onRefreshQuote = function () {
      return _this.actions.retrieveOrderQuote(_this.state.currentCustomer.Id, _this.state.asyncId).then(function (response) {
        _this.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this.uiNotificationService.transientError(error.translatedMessage);
      });
    }.bind(_this);
    _this.attemptNextStep = function () {
      _this.wizardContinueClicked = true;
      if (_this.wizardForm) {
        _this.wizardForm.highlightErrorMessages();
      }
      if (_this.state.currentStepIsInvalid || !_this.state.cartHasItems || _this.wizardForm.$invalid) {
        _this.wizardForm.$setSubmitted();
        $log.warn('The current step has errors');
      } else if (_this.state.isProductsStep) {
        _this.wizardForm.$setPristine();
        _this.actions.goToNextStep();
      } else if (_this.state.isCheckoutStep) {
        // The outer wizard submit button doesn't live inside of a form. The original wizard was built
        // without an outer form but form(s) now wrap individual steps to make it backwards compatible.
        // As a result we have to manually set submitted.
        _this.wizardForm.$setSubmitted();
        if (!_this.isCheckoutStepInvalid()) {
          _this.submitOrder();
        }
      }
    };

    // Preview Renewal Statements Popup Dialog bits
    _this._previewRenewalStatementsPopupApi = null;
    _this.showPreviewRenewalStatementsDialog = false;
    _this.previewRenewalStatementsPopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        _this._previewRenewalStatementsPopupApi = event.api;
      }
    };
    if (_this.state.skipToCheckout) {
      _this.deregisterUnsavedChanges();
      $timeout(function () {
        _this.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
      });
    }
    _this.onOrderAdditionalPropertyListUpdated = function () {
      _this.actions.setEditOrderAdditionalProperty(_this.state.orderAdditionalPropertyListMap);
    };
    _this.onOrderAdditionalPropertyChanged = function (id, newValue) {
      _this.actions.setEditOrderAdditionalPropertyOnChange(id, newValue);
    };
  };
  this.isCheckoutStepInvalid = function () {
    return _this.wizardForm && _this.wizardForm.$invalid && _this.wizardForm['$ctrl.fdoExecutionOptionsForm'] && _this.wizardForm['$ctrl.fdoExecutionOptionsForm'].$invalid;
  };
  this.calculateOrderQuote = function () {
    if (!_this.isServiceFeatureOrder && !_this.state.isCheckoutStep || !_this.hasDataRequiredForOrderQuote()) {
      _this.actions.clearOrderQuote();
      return;
    }
    if (!_this.state.cartHasItems && _this.state.isCheckoutStep) {
      _this.goToPreviousStep();
      return;
    }

    // Skip SubscriptionOrder builder for DBSS, which will only need customer id and shopping cart items
    var order = _this.state.isDbssShoppingCart ? {
      customerId: _this.state.currentCustomer.Id,
      shoppingCart: _this.state.shoppingCart
    } : _this.state.isServiceFeatureShoppingCart ? {
      customerId: _this.state.currentCustomer.Id,
      addItems: _this.state.submitChangeOfServiceForServiceFeatureWithoutQuantitiesRequest.AddItems,
      removeItems: _this.state.submitChangeOfServiceForServiceFeatureWithoutQuantitiesRequest.RemoveItems
    } : new SubscriptionOrder(_this.state, false).createOrder();
    var calculateQuoteFn;
    if (_this.state.locationCodes && _this.state.locationCodes.length) {
      _this.appendTaxAndGlPayload(order);
    }
    if (_this.isServiceFeatureOrder) {
      calculateQuoteFn = _this.actions.calculateChangeOfServiceOrderQuote;
      order.paymentInstrumentIds = _this.state.paymentInstrumentIds;
    } else {
      if (_this.state.isCreatingMode) {
        calculateQuoteFn = _this.actions.calculateOrderQuote;
      } else if (_this.state.isReplacingMode || _this.state.isModifyingMode) {
        calculateQuoteFn = _this.actions.calculateModifyOrderQuote;
      } else if (_this.state.isRestoringMode) {
        calculateQuoteFn = _this.actions.calculateRenewOrderQuote;
      }
    }
    if (calculateQuoteFn) {
      return calculateQuoteFn(order).then(function () {
        if (_this.state.orderRequiresShipping) {
          // COQ uses first payment method by default, we need to reflect this on client
          if (!_this.state.shippingMethodId && _this.state.shippingMethods.length > 0) {
            _this.actions.setSelectedShippingMethodId(_this.state.shippingMethods[0].Id);
          }
        }
        if (_this.state.asyncId) {
          _this.repeatRetrieveQuote();
        }
      });
    }
  };
  this.removeProductListItemSelected = function (cartItem) {
    var selectedProduct = _this.state.productsList ? _this.state.productsList.find(function (product) {
      return product.Id === cartItem.productId;
    }) : null;
    var inShoppingCart = _this.state.shoppingCart.Items && _this.state.shoppingCart.Items.length ? _this.state.shoppingCart.Items.find(function (item) {
      return item.ProductId === cartItem.productId;
    }) : null;
    if (!inShoppingCart && selectedProduct) {
      selectedProduct.isSelected = false;
    }
  };
  this.updateShoppingCartWithCouponsAndCalculateOrderQuote = function () {
    if (!_this.state.isReplacingMode && !_this.state.isModifyingMode && !_this.state.isRestoringMode) {
      var couponCodes = pluck('name', _this.state.couponCodes);
      return _this.actions.updateShoppingCartWithLatest({
        customerId: _this.state.currentCustomer.Id,
        discretionaryDiscountIds: _this.state.discretionaryDiscountIds,
        discretionaryDiscountReasonCode: pathOr(null, ['discretionaryDiscountReason', 'value'], _this.state),
        redemptionCodes: couponCodes,
        shoppingCart: _this.state.shoppingCart
      }, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS).then(function () {
        _this.calculateOrderQuote();
      });
    } else {
      // we cannot call updateShoppingCart for replace, modify, and restore orders
      _this.calculateOrderQuote();
    }
  };
  this.onRemoveCartItem = function (cartItem) {
    if (!_this.state.isReplacingMode && !_this.state.isModifyingMode && !_this.state.isRestoringMode) {
      var couponCodes = pluck('name', _this.state.couponCodes);
      if (_this.isServiceFeatureOrder) {
        var existingQuantity = getExistingQuantities(cartItem.pricingPlanId, cartItem.productId, _this.state.featureOrderQuantities);
        var pricingPlans = [{
          Id: cartItem.pricingPlanId,
          cartQuantity: existingQuantity - cartItem.quantity
        }];
        _this.state.shoppingCart.Items.forEach(function (shoppingCartItem) {
          if (cartItem.productId === shoppingCartItem.ProductId && cartItem.pricingPlanId !== shoppingCartItem.PricingPlanId) {
            var cartItemToModify = {
              Id: shoppingCartItem.PricingPlanId,
              cartQuantity: 1
            };
            pricingPlans.push(cartItemToModify);
          }
          ;
        });
        var product = _this.state.productsList.find(function (prod) {
          return prod.Id === cartItem.productId;
        });
        var shoppingCart = processServiceFeatures(cartItem.productId, product, pricingPlans, _this.state.shoppingCart, _this.state.featureOrderQuantities, _this.state.routeParams, _this.state.orders, _this.state.submitChangeOfServiceForServiceFeatureRequest);
        _this.actions.updateServiceFeatureQuantityPromise({
          AddItems: shoppingCart.AddItems,
          RemoveItems: shoppingCart.RemoveItems
        });
        var model = {
          products: [],
          customerId: _this.state.currentCustomer.Id,
          shoppingCart: shoppingCart,
          redemptionCodes: []
        };
        _this.serviceFeatureModel = model;
        return _this.actions.editMultipleAndUpdateShoppingCart(model, DBSS_UPDATE_CART_ADDITIONAL_OPTIONS).then(function () {
          if (_this.state.isCheckoutStep) {
            _this.calculateOrderQuote();
          }
          uiNotificationService.success(i18n.translate(itemInRemoveItems ? CustomerCareKeys.CART.ITEM_ADDED_BACK_TO_CART_SUCCESS : CustomerCareKeys.CART.ITEM_REMOVE_SUCCESS));
        });
      } else {
        return _this.actions.removeFromAndUpdateShoppingCart({
          index: cartItem.index,
          customerId: _this.state.currentCustomer.Id,
          shoppingCart: _this.state.shoppingCart,
          redemptionCodes: couponCodes || []
        }, _this.state.isDbssShoppingCart ? DBSS_UPDATE_CART_ADDITIONAL_OPTIONS : undefined).then(function () {
          _this.removeProductListItemSelected(cartItem);
          _this.calculateOrderQuote();
        });
      }
    }
  };
  this.orderConfirmationRedirect = function () {
    _this.orderConfirmationPopup.close();
    _this.deregisterUnsavedChanges();
    if (_this.state.isModifyingMode && _this.state.isPreviousRouteDashboard) {
      $state.go('index.customercare.customer.dashboard', {});
    } else if (_this.state.isReplacingMode || _this.state.isModifyingMode) {
      $state.go('index.customercare.customer.subscriptions.list');
    } else if (_this.state.isRestoringMode) {
      $state.go(SUBSCRIPTION_DETAILS_ROUTE, {
        subscriptionId: _this.state.currentSubscription.Id
      }, {
        reload: true
      });
    } else {
      $state.go('index.customercare.customer.dashboard', {});
    }
  };
  this.submitOrder = function () {
    if (uiNotificationService.numActiveToasts()) {
      uiNotificationService.clear();
    }
    var subscriptionOrder = _this.state.isGiftOrder ? {
      discretionaryDiscountReasonCode: pathOr(null, ['id'], _this.state.discretionaryDiscountReason),
      giftOrderInfo: _this.state.giftOrderInfo
    } : {
      discretionaryDiscountReasonCode: pathOr(null, ['id'], _this.state.discretionaryDiscountReason)
    };
    // Skip SubscriptionOrder builder for DBSS, which will only need customer id and shopping cart items
    var order = _this.state.isDbssShoppingCart ? {
      customerId: _this.state.currentCustomer.Id,
      orderDetails: _this.state.orderDetails,
      shoppingCart: _this.state.shoppingCart,
      executionOptions: _this.state.executionOptions
    } : _this.state.isServiceFeatureShoppingCart ? {
      customerId: _this.state.currentCustomer.Id,
      addItems: _this.state.submitChangeOfServiceForServiceFeatureWithoutQuantitiesRequest.AddItems,
      removeItems: _this.state.submitChangeOfServiceForServiceFeatureWithoutQuantitiesRequest.RemoveItems,
      executionOptions: _this.state.executionOptions
    } : new SubscriptionOrder(_this.state, true).createOrder(subscriptionOrder);
    if (_this.state.orderAdditionalProperties.length) {
      order.additionalProperties = _this.state.orderAdditionalProperties;
    }
    if (_this.state.locationCodes && _this.state.locationCodes.length) {
      _this.taxAndGlValuesRequired = true;
      _this.appendTaxAndGlPayload(order);
    }
    var submitOrderFn;
    if (_this.isServiceFeatureOrder) {
      submitOrderFn = _this.actions.submitServiceFeatureOrder;
    } else {
      if (_this.state.isGiftOrder) {
        submitOrderFn = _this.actions.submitGiftOrder;
      } else if (_this.state.isCreatingMode) {
        submitOrderFn = _this.actions.submitOrder;
      } else if (_this.state.isRestoringMode) {
        submitOrderFn = _this.actions.submitRestoreOrder;
      } else if (_this.state.isReplacingMode || _this.state.isModifyingMode) {
        submitOrderFn = _this.actions.submitModifyOrder;
      }
    }
    if (submitOrderFn && !_this.taxAndGlValuesRequired) {
      return submitOrderFn(order).then(function () {
        _this.deregisterUnsavedChanges();
        _this.orderConfirmationPopup.open();
        if (_this.state.isCreatingMode) {
          _this.actions.setReloadSubscriberStateFlag(true);
        }
      }).catch(function (error) {
        error.Code === convertStringToNumber(FaultCodeKeys.LITE_CUSTOMER_SUBMISSION_ERROR_CODE) ? _this.openEditProfileInformationPopup() : _this.submitOrderErrorPopup.open();
      });
    } else if (_this.taxAndGlValuesRequired) {
      var errorMessage = i18n.translate(CustomerCareKeys.TAX_AND_GL_LOCATION.SELECT_LOCATION_TOAST_MESSAGE);
      uiNotificationService.error(errorMessage, null, {
        timeOut: 0,
        tapToDismiss: true
      });
    }
  };
  this.goToPreviousStep = function () {
    var couponCodes = pluck('name', _this.state.couponCodes);
    if (_this.state.isCheckoutStep) {
      _this.actions.clearOrderQuote();
      if (_this.state.couponCodes && _this.state.couponCodes.length) {
        if (!_this.state.isReplacingMode) {
          _this.actions.updateShoppingCartWithLatest({
            customerId: _this.state.currentCustomer.Id,
            shoppingCart: _this.state.shoppingCart,
            redemptionCodes: couponCodes || []
          }, _this.state.isDbssShoppingCart ? DBSS_UPDATE_CART_ADDITIONAL_OPTIONS : undefined);
        }
      }
    }
    _this.actions.goToPreviousStep();
    _this.wizardContinueClicked = false;
  };
  this.stepSelected = function () {
    // Disabled per Kelly until it is worked in a future story
    // TODO: re-enable
    // this.actions.goToStep(selectedStep.name);
  };
  this.cancelClick = function () {
    if (!unsavedChangesPrompt.hasUnsavedChanges()) {
      _this.handleCancel();
    }
  };
  this.tabSelected = function (selectedTab) {
    var selectedIndex = _this.state.tabs.findIndex(function (tab) {
      return tab === selectedTab;
    });
    _this.actions.setSelectedTab(selectedIndex);
  };
  this.handleCancel = function () {
    if (_this.state.skipToCheckout) {
      clearStore(_this.actions);
    }
    _this.actions.cancelOrder();
    _this.deregisterUnsavedChanges();
  };
  this.deregisterUnsavedChanges = function () {
    _this.actions.unregisterUnsavedChanges('productsOrderWizard');
  };
  this.closeOrderErrorPopup = function () {
    _this.submitOrderErrorPopup.close();
  };
  this.shouldShowBackButton = function () {
    return _this.state.skipToCheckout ? false : !_this.state.isProductsStep;
  };
  this.hasDataRequiredForOrderQuote = function () {
    var hasPaymentInstruments = _this.state.paymentInstrumentIds.length > 0 || _this.state.paymentInstruments.length > 0;
    var hasShippingAddress = !!_this.state.shippingAddressId;
    return (hasPaymentInstruments || !_this.state.shoppingCart.PaymentInstrumentRequired) && (hasShippingAddress || !_this.state.orderRequiresShipping);
  };
  this.initializeReplaceMode = function () {
    if (!_this.state.currentSubscription) {
      return _this.actions.retrieveSubscription(_this.state.currentCustomer.Id, {
        Id: _this.state.currentSubscriptionId
      }).then(function () {
        var cartItem = SubscriptionHelper.createSubscriptionCartItem(_this.state.currentSubscription, _this.state.currentSubscriptionChildItemId);
        _this.actions.initializeReplaceOrder(cartItem);
      }).catch(function () {
        if (_this.state.subscriptionError) {
          uiNotificationService.error(_this.state.subscriptionError.message);
        }
      });
    } else {
      var cartItem = SubscriptionHelper.createSubscriptionCartItem(_this.state.currentSubscription, _this.state.currentSubscriptionChildItemId);
      _this.actions.initializeReplaceOrder(cartItem);
    }
  };
  this.$onDestroy = function () {
    clearStore(_this.actions);
    disconnectRedux();
  };
  this.handlePreviewRenewalStatements = function () {
    _this._openPreviewRenewalStatementsPopup();
  };
  this.handleClosePreviewRenewalStatementsDialog = function () {
    _this._closePreviewRenewalStatementsPopup();
  };
  this._openPreviewRenewalStatementsPopup = function () {
    _this.showPreviewRenewalStatementsDialog = true;
    $timeout(_this._previewRenewalStatementsPopupApi.open);
  };
  this._closePreviewRenewalStatementsPopup = function () {
    _this.showPreviewRenewalStatementsDialog = false;
    _this._previewRenewalStatementsPopupApi.close();
  };
  this.updateOrderPopupConfig = {
    onRegisterApi: function onRegisterApi(_ref3) {
      var api = _ref3.api;
      _this.updateOrderPopupApi = api;
    }
  };
  this.openUpdateOrderConfirmation = function (productId) {
    _this.productId = productId;
    $timeout(_this.updateOrderPopupApi.open);
  };
  this.closeUpdateOrderPopup = function (result) {
    if (result) {
      _this.openProductModal(i18n.translate(CustomerCareKeys.PRODUCT_OPTIONS.OPTIONS), _this.productId);
    }
    _this.updateOrderPopupApi.close();
  };
  this.onProductSelected = function () {
    if (_this.state.isReplacingMode && _this.state.isProductsStep) {
      _this.attemptNextStep();
    } else if (_this.state.isCheckoutStep) {
      _this.calculateOrderQuote();
    }
  };
  this.getOrderNumber = function () {
    var createOrderNumber = path(['state', 'createdOrder', 'OrderNumber'], _this);
    return createOrderNumber ? createOrderNumber : path(['state', 'removedOrder', 'OrderNumber'], _this);
  };
  this.openEditProfileInformationPopup = function () {
    _this.showCustomerPopup = true;
    $timeout(function () {
      _this.editProfileInformationPopupApi.open();
    });
  };
  this.closeEditProfileInformationPopup = function () {
    _this.showCustomerPopup = false;
    _this.editProfileInformationPopupApi.close();
  };
  this.onSubmitEditCustomerForm = function () {
    _this.showLoadingIndicator = true;
    _this.closeEditProfileInformationPopup();
    uiNotificationService.transientSuccess(i18n.translate(CustomerCareKeys.PROFILE_PAGE.UPDATE_SUCCESS_MESSAGE));
  };
  this.appendTaxAndGlPayload = function (order) {
    var isCustomerAddressConfigured = false;
    var isStoreLocationConfigured = false;
    var isServiceIdentifierConfigured = false;
    if (_this.state.locationCodes.length) {
      isCustomerAddressConfigured = _this.state.locationCodes.includes(TAX_LOCATION_CONSTANTS.CUSTOMER_ADDRESS) && _this.state.selectedCustomerAddress !== null;
      isStoreLocationConfigured = _this.state.locationCodes.includes(TAX_LOCATION_CONSTANTS.STORE_LOCATION) && _this.state.selectedInventoryStore !== null;
      isServiceIdentifierConfigured = _this.state.locationCodes.includes(TAX_LOCATION_CONSTANTS.NPA_NXX) && _this.state.selectedServiceIdentifier !== null;
    }
    if (isCustomerAddressConfigured || isStoreLocationConfigured || isServiceIdentifierConfigured) {
      var taxAndGlPayload = Object.assign({}, isCustomerAddressConfigured && {
        AddressId: _this.state.selectedCustomerAddress.addressId
      }, isStoreLocationConfigured && {
        StoreId: convertStringToNumber(_this.state.selectedInventoryStore.Value)
      }, isServiceIdentifierConfigured && {
        ServiceIdentifierValue: _this.state.selectedServiceIdentifier.SerialNumber
      });
      order.orderTaxLocation = taxAndGlPayload;
      if (_this.state.locationCodes.length === Object.keys(taxAndGlPayload).length) {
        _this.taxAndGlValuesRequired = false;
      }
    }
    return order;
  };
}
export default {
  template: require('./create.products.order.wizard.html'),
  controller: ProductsWizardController,
  controllerAs: 'productsController'
};